import React from 'react';
import Investering from 'pages/raadgivning/investeringsraadgivning';


export default function InvesteringRedirect() {
    return <Investering/>;
}
